export const organisationFolderContentsData = [
  {
    key: "1",
    module: "Branding Themes ",
    records: 42,
    actions: ["XML", "JSON", "CSV", "View Attachments (53)"],
  },
  {
    key: "2",
    module: "Manual Journals",
    records: 42,
    actions: ["XML", "JSON", "CSV"],
  },
  {
    key: "3",
    module: "Profit and Loss",
    records: 42,
    actions: ["CSV", "View Attachments (53)"],
  },
  {
    key: "1",
    module: "Branding Themes ",
    records: 42,
    actions: ["XML", "JSON", "CSV", "View Attachments (53)"],
  },
  {
    key: "2",
    module: "Manual Journals",
    records: 42,
    actions: ["XML", "JSON", "CSV"],
  },
  {
    key: "3",
    module: "Profit and Loss",
    records: 42,
    actions: ["CSV", "View Attachments (53)"],
  },
  {
    key: "1",
    module: "Branding Themes ",
    records: 42,
    actions: ["XML", "JSON", "CSV", "View Attachments (53)"],
  },
  {
    key: "2",
    module: "Manual Journals",
    records: 42,
    actions: ["XML", "JSON", "CSV"],
  },
  {
    key: "3",
    module: "Profit and Loss",
    records: 42,
    actions: ["CSV", "View Attachments (53)"],
  },
];

export const financialColumnValues = [
  "balance_sheet",
  "trial_balance",
  "profit_and_loss",
];
